@if (errorMessage) { <div class="error-message">{{ errorMessage | translate }}</div> }
  <div class="orch-table-panel">
    <app-orchestration-table-heading heading="Assignments" [query]="searchQuery" (queryChange)="onCatalogSearch($event)">
      <div tableActions class="table-actions">
        @if (allowCreate()) {
          <app-primary-button
            title="Create assignment"
            icon="pi pi-plus"
            (action)="create()"
          ></app-primary-button>
        }
        <ng-content select="[listActions]"></ng-content>
        @if (allowRestartFailed()) {
          <app-secondary-button
            title="ORCH_RESTART_FAILED_AND_SKIPPED"
            icon="pi pi-replay"
            [disable]="restartFailedSaving"
            [loading]="restartFailedSaving"
            (action)="requestRestartFailed()"
          ></app-secondary-button>
        }
        <app-secondary-button
          title="Refresh"
          icon="refresh"
          [disable]="loading"
          [loading]="loading"
          (action)="load()"
        ></app-secondary-button>
      </div>
    </app-orchestration-table-heading>
    <div class="assignment-toolbar">
      <div class="assignment-toolbar__group">
        <app-assignment-result-filter
          [selected]="resultFilter"
          (selectedChange)="onResultFilterChange($event)"
        ></app-assignment-result-filter>
      </div>
      <div class="assignment-toolbar__group state-filters">
        @for (chip of listChips; track chip.id) {
          <button
            type="button"
            class="filter-chip"
            [class.active]="chip.selected"
            (click)="selectListMode(chip.id)">
            <span>{{ chip.label | translate }}</span>
          </button>
        }
      </div>
      <div class="assignment-toolbar__group state-filters">
        @for (chip of stateChips; track chip.id) {
          <button
            type="button"
            class="filter-chip"
            [class.active]="chip.selected"
            (click)="selectStateFilter(chip.id)">
            <span>{{ chip.label | translate }}</span>
          </button>
        }
      </div>
      <div class="assignment-toolbar__group assignment-toolbar__fields">
        <app-orchestration-process-select
          [model]="processFilter ?? ''"
          (modelChange)="onProcessFilterChange($event)"
          [options]="processOptions"
          [showSelectedSubtitle]="false"
          [showClear]="true"
          [placeholder]="'Process' | translate"
          width="280px"
        ></app-orchestration-process-select>
        @if (!workerSelectHidden()) {
          <msf-select
            [model]="workerFilter ?? ''"
            (modelChange)="onWorkerFilterChange($event)"
            [options]="workerOptions"
            optionValue="id"
            optionLabel="label"
            [translateBy]="'none'"
            [showClear]="true"
            [placeholder]="'Executed on' | translate"
            width="240px"
          ></msf-select>
        }
        @if (!lockedWindow()) {
          <app-date-picker
            [ngModel]="createdRange"
            (ngModelChange)="onCreatedRangeChange($event)"
            selectionMode="range"
            [showClear]="true"
            [placeholder]="'Created' | translate"
          ></app-date-picker>
        }
      </div>
    </div>
    @if (loading && ((listMode === 'groups' && groups.length === 0) || (listMode === 'runs' && operations.length === 0))) {
      <app-loading [loading]="true"></app-loading>
    } @else {
      <div class="orch-table-grid" [class.orch-table-grid--busy]="loading" [attr.aria-busy]="loading">
      @if (loading) {
        <app-loading [loading]="true"></app-loading>
      }
      @if (listMode === 'groups') {
        <div class="table-wrapper"><table><thead><tr>
          @for (column of groupSortColumns; track column.id) {
            <th [attr.aria-sort]="sortColumn === column.id ? sortAria : null">
              <button type="button" class="column-sort" (click)="onSortColumn(column.id)">
                <span>{{ column.label | translate }}</span>
                @if (sortColumn === column.id) {
                  <i class="pi" [class.pi-chevron-up]="sortDir === 'asc'" [class.pi-chevron-down]="sortDir === 'desc'" aria-hidden="true"></i>
                }
              </button>
            </th>
          }
          <th>{{ 'RSS' | translate }}</th>
        </tr></thead><tbody>
          @for (group of groups; track group.processKey) {
            <tr class="group-row" (click)="showProcessRuns(group.processKey)">
              <td class="name-cell">
                <strong>{{ group.displayTitle | translate }}</strong>
                <small>
                  <app-copyable-identifier [value]="group.processKey"></app-copyable-identifier>
                </small>
              </td>
              <td (click)="$event.stopPropagation()">
                <button type="button" class="group-edge" (click)="openGroupAssignment(group.latest.id)">
                  <span>{{ group.latest.createdAt | dateFormatLang:translate.currentLang:true }}</span>
                  <p-tag
                    [value]="(group.latest.state || '—') | translate"
                    [severity]="group.latest.stateSeverity"
                    [pTooltip]="group.latest.error || ''"
                    [tooltipDisabled]="!group.latest.error"
                    tooltipPosition="top"
                  ></p-tag>
                  <app-assignment-result-cell
                    [resultCount]="group.latest.resultCount"
                    [tooltip]="null"
                  ></app-assignment-result-cell>
                </button>
              </td>
              <td>
                <app-assignment-rss-cell [rss]="group.rss"></app-assignment-rss-cell>
              </td>
            </tr>
          } @empty {
            @if (!loading) {
              <tr><td colspan="3" class="empty-state">{{ emptyListMessage | translate }}</td></tr>
            }
          }
        </tbody></table></div>
      } @else {
      <div class="table-wrapper"><table><thead><tr>
        @for (column of runSortColumns; track column.id) {
          <th [attr.aria-sort]="sortColumn === column.id ? sortAria : null">
            <button type="button" class="column-sort" (click)="onSortColumn(column.id)">
              <span>{{ column.label | translate }}</span>
              @if (sortColumn === column.id) {
                <i class="pi" [class.pi-chevron-up]="sortDir === 'asc'" [class.pi-chevron-down]="sortDir === 'desc'" aria-hidden="true"></i>
              }
            </button>
          </th>
        }
        <th>{{ 'RSS' | translate }}</th>
        <th>{{ 'Actions' | translate }}</th>
      </tr></thead><tbody>
        @for (operation of operations; track operation.id) {
          <tr class="assignment-row" (click)="openDetails(operation)">
            <td class="name-cell">
              <strong>{{ operation.displayTitle | translate }}</strong>
              <small>
                <app-copyable-identifier [value]="operation.operationType || ''"></app-copyable-identifier>
              </small>
            </td>
            <td class="status-cell">
              <p-tag
                [value]="operation.outcomeLabel | translate"
                [severity]="operation.stateSeverity"
                [pTooltip]="operation.error || operation.outcomeReason || ''"
                [tooltipDisabled]="!operation.error && !operation.outcomeReason"
                tooltipPosition="top"
              ></p-tag>
              @if (operation.statusAt) {
                <small>{{ operation.statusAt | dateFormatLang:translate.currentLang:true }}</small>
              }
              @if (operation.error) {
                <small>{{ operation.error }}</small>
              }
              @if (operation.outcomeReason) {
                <small>{{ operation.outcomeReason }}</small>
              }
            </td>
            <td>
              <app-assignment-host-label
                [serviceName]="operation.workerServiceName"
                [hostName]="operation.workerHostName"
                [workerId]="operation.workerId"
                [fallback]="operation.hostLabel"
              ></app-assignment-host-label>
            </td>
            <td>{{ operation.createdAt | dateFormatLang:translate.currentLang:true }}</td>
            <td>{{ operation.progressPercentage ?? 0 }}%</td>
            <td><div>{{ 'PROCESSING_TIME' | translate }}: {{ operation.durationLabel }}</div><small>{{ 'QUEUE_WAIT_TIME' | translate }}: {{ operation.queueLabel }}</small></td>
            <td>
              <app-assignment-result-cell
                [resultCount]="operation.resultCount"
                [tooltip]="operation.resultTooltip"
              ></app-assignment-result-cell>
            </td>
            <td>
              <app-assignment-rss-cell [rss]="operation.rss"></app-assignment-rss-cell>
            </td>
            <td class="actions" (click)="$event.stopPropagation()">
              <button
                pButton
                type="button"
                icon="pi pi-align-left"
                [text]="true"
                [pTooltip]="'Execution logs' | translate"
                tooltipPosition="top"
                (click)="openDetails(operation)"
              ></button>
              @if (operation.hasSatelliteProducts) {
                <button
                  pButton
                  type="button"
                  icon="pi pi-list"
                  [text]="true"
                  [pTooltip]="'Products' | translate"
                  tooltipPosition="top"
                  (click)="showProducts(operation)"
                ></button>
              }
              <button
                pButton
                type="button"
                icon="pi pi-calendar-plus"
                [text]="true"
                [pTooltip]="'Make subscription' | translate"
                tooltipPosition="top"
                (click)="makeSubscription(operation)"
              ></button>
              <button
                pButton
                type="button"
                icon="pi pi-copy"
                [text]="true"
                [pTooltip]="'Copy assignment' | translate"
                tooltipPosition="top"
                (click)="requestCopy(operation)"
              ></button>
              @if (operation.canRestart) {
                <button
                  pButton
                  type="button"
                  icon="pi pi-replay"
                  [text]="true"
                  [pTooltip]="'Restart assignment' | translate"
                  tooltipPosition="top"
                  (click)="requestRestart(operation)"
                ></button>
              }
              @if (operation.canCancel) {
                <button
                  pButton
                  type="button"
                  icon="pi pi-stop-circle"
                  severity="danger"
                  [text]="true"
                  [pTooltip]="'Cancel assignment' | translate"
                  tooltipPosition="top"
                  (click)="requestCancellation(operation)"
                ></button>
              }
            </td>
          </tr>
        } @empty {
          @if (!loading) {
            <tr><td colspan="9" class="empty-state">{{ emptyListMessage | translate }}</td></tr>
          }
        }
      </tbody></table></div>
      }
      </div>
      @if (listMode === 'runs') {
      <app-custom-paginator
        [first]="first"
        [pageSize]="pageSize"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="pageSizeOptions"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
      ></app-custom-paginator>
      }
    }
  </div>

@if (allowCreate()) {
<p-dialog [resizable]="false" [draggable]="false" [(visible)]="dialogVisible" [modal]="true" [style]="{ width: 'min(960px, 96vw)' }" [header]="'Create assignment' | translate">
  <div class="form-grid">
    <label class="full-width">
      <span>{{ 'Process' | translate }}</span>
      <app-orchestration-process-select
        [(model)]="processKey"
        [options]="processOptions"
        [placeholder]="'Process' | translate"
      ></app-orchestration-process-select>
    </label>
    <app-assignment-start-form class="full-width" [processKey]="processKey"></app-assignment-start-form>
  </div>
  <ng-template #footer>
    <app-secondary-button title="Cancel" (action)="dialogVisible = false"></app-secondary-button>
    <app-primary-button
      title="Run"
      [loading]="saving"
      [disable]="!canStartForm() || saving"
      (action)="start()"
    ></app-primary-button>
  </ng-template>
</p-dialog>
}

<app-make-subscription-dialog (failed)="errorMessage = $event"></app-make-subscription-dialog>

<p-dialog [resizable]="false" [draggable]="false" [(visible)]="cancellationVisible" [modal]="true" [style]="{ width: 'min(520px, 94vw)' }" [header]="'Cancel assignment' | translate">
  <p>{{ 'Cancel assignment confirmation' | translate }}</p>
  <ng-template #footer>
    <app-secondary-button title="Keep running" (action)="cancellationVisible = false"></app-secondary-button>
    <button pButton type="button" severity="danger" icon="pi pi-stop-circle" [loading]="cancellationSaving" [label]="'Cancel assignment' | translate" (click)="confirmCancellation()"></button>
  </ng-template>
</p-dialog>

<p-dialog [resizable]="false" [draggable]="false" [(visible)]="restartVisible" [modal]="true" [style]="{ width: 'min(520px, 94vw)' }" [header]="'Restart assignment' | translate">
  <p>{{ 'Restart assignment confirmation' | translate }}</p>
  <ng-template #footer>
    <app-secondary-button title="Keep as-is" (action)="restartVisible = false"></app-secondary-button>
    <app-primary-button
      title="Restart assignment"
      icon="pi pi-replay"
      [loading]="restartSaving"
      (action)="confirmRestart()"
    ></app-primary-button>
  </ng-template>
</p-dialog>

<p-dialog [resizable]="false" [draggable]="false" [visible]="restartFailedVisible" (visibleChange)="onRestartFailedVisible($event)" [modal]="true" [style]="{ width: 'min(520px, 94vw)' }" [header]="'ORCH_RESTART_FAILED_AND_SKIPPED' | translate">
  @if (restartFailedEveryProcess) {
    <p>{{ 'ORCH_RESTART_FAILED_AND_SKIPPED_ALL_CONFIRMATION' | translate }}</p>
  } @else {
    <p>{{ 'ORCH_RESTART_FAILED_AND_SKIPPED_PROCESS_CONFIRMATION' | translate }}</p>
  }
  <ng-template #footer>
    <app-secondary-button
      title="Keep as-is"
      [disable]="restartFailedSaving"
      (action)="closeRestartFailed()"
    ></app-secondary-button>
    <app-primary-button
      title="ORCH_RESTART_FAILED_AND_SKIPPED"
      icon="pi pi-replay"
      [loading]="restartFailedSaving"
      (action)="confirmRestartFailed()"
    ></app-primary-button>
  </ng-template>
</p-dialog>

<p-dialog [resizable]="false" [draggable]="false" [(visible)]="copyVisible" [modal]="true" [style]="{ width: 'min(520px, 94vw)' }" [header]="'Copy assignment' | translate">
  <p>{{ 'Copy assignment confirmation' | translate }}</p>
  <ng-template #footer>
    <app-secondary-button title="Keep as-is" (action)="copyVisible = false"></app-secondary-button>
    <app-primary-button
      title="Copy assignment"
      icon="pi pi-copy"
      [loading]="copySaving"
      (action)="confirmCopy()"
    ></app-primary-button>
  </ng-template>
</p-dialog>

<p-dialog [resizable]="false"
  [visible]="productsVisible"
  [modal]="true"
  [draggable]="false"
  [dismissableMask]="true"
  [style]="{ width: 'min(1100px, 96vw)' }"
  [header]="'Assignment products' | translate"
  (visibleChange)="setProductsVisible($event)">
  <div class="table-wrapper"><table><thead><tr><th>{{ 'Product ID' | translate }}</th><th>{{ 'Satellite product ID' | translate }}</th><th>{{ 'Provider' | translate }}</th><th>{{ 'Acquisition date' | translate }}</th><th>{{ 'Cloud cover' | translate }}</th><th>{{ 'Download status' | translate }}</th><th>{{ 'Processing stage' | translate }}</th></tr></thead><tbody>
    @for (product of products; track product.id) {
      <tr>
        <td>
          <app-copyable-identifier [value]="product.externalProductId || ''"></app-copyable-identifier>
        </td>
        <td>
          <app-copyable-identifier [value]="product.id || ''" [link]="product.analysisUrl"></app-copyable-identifier>
        </td>
        <td>{{ product.provider }}</td>
        <td>{{ product.originDate | dateFormatLang:translate.currentLang }}</td>
        <td>{{ product.cloudCover ?? '—' }}</td>
        <td>{{ (product.downloadState ?? '—') | translate }}</td>
        <td>{{ (product.processingStage ?? '—') | translate }}</td>
      </tr>
    }
  </tbody></table></div>
</p-dialog>
